// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Product Catalogue API
 * Endpoints for querying product catalogue data including products and their versions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HealthResponse
 */
export interface HealthResponse {
  /**
   *
   * @type {string}
   * @memberof HealthResponse
   */
  message: string;
}

/**
 * Check if a given object implements the HealthResponse interface.
 */
export function instanceOfHealthResponse(
  value: object,
): value is HealthResponse {
  if (!('message' in value) || value['message'] === undefined) return false;
  return true;
}

export function HealthResponseFromJSON(json: any): HealthResponse {
  return HealthResponseFromJSONTyped(json, false);
}

export function HealthResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HealthResponse {
  if (json == null) {
    return json;
  }
  return {
    message: json['message'],
  };
}

export function HealthResponseToJSON(json: any): HealthResponse {
  return HealthResponseToJSONTyped(json, false);
}

export function HealthResponseToJSONTyped(
  value?: HealthResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    message: value['message'],
  };
}
